$ = jQuery.noConflict()

$(document).ready(function () {
  $('.input-field').focusin(function (e) {
    $(this).addClass('active')
  })

  $('.input-field').focusout(function (e) {
    if ($(this).find('.wpcf7-form-control-wrap input').attr('value').length <= 0) {
      $(this).removeClass('active')
    } else if ($(this).find('.wpcf7-form-control-wrap input').attr('value').length >= 0) {
      $(this).addClass('active')
    }
  })
})

